jQuery(document).ready(function($){

	$(function() {
	    $('.widget_media_image img').after('<div class="mega-img-overlay"></div>');
	});
	
});